module.exports = __webpack_public_path__ + "img/gb7244.prt.d01c20f3.jpg";